/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_FavouritesInputs */

const en_filter_favourites = /** @type {(inputs: Filter_FavouritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favourites`)
};

const de_filter_favourites = /** @type {(inputs: Filter_FavouritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoriten`)
};

/**
* | output |
* | --- |
* | "Favourites" |
*
* @param {Filter_FavouritesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_favourites = /** @type {((inputs?: Filter_FavouritesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_FavouritesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_favourites(inputs)
	return en_filter_favourites(inputs)
});